/**
 * Shows the newsletter consent refusal in the form's own error style.
 *
 * The checkbox carries `required`, so the browser already refuses to submit without it - that
 * part works with this file absent. What it cannot do well is say so: the input is opacity:0
 * with the label drawing the box, so the native bubble points at something invisible, and its
 * wording is the browser's, not the shop's.
 *
 * So the refusal is caught and rendered as the same message the rest of the form uses. Nothing
 * here can let an unticked form through - it only reacts after the browser has already said no.
 */
(function () {
  'use strict';

  /**
   * @param {HTMLInputElement} box
   * @param {boolean} show
   */
  function setError(box, show) {
    const error = document.getElementById(box.getAttribute('aria-describedby'));
    if (error) error.hidden = !show;

    box.setAttribute('aria-invalid', show ? 'true' : 'false');
  }

  function bind(box) {
    if (box.dataset.termsBound) return;
    box.dataset.termsBound = 'true';

    const form = box.closest('form');
    if (!form) return;

    /* Fires on the control the browser refused, before the bubble would appear. */
    box.addEventListener('invalid', (evt) => {
      evt.preventDefault();
      setError(box, true);

      /* The label is what a customer can see and click, so focus belongs there. */
      const label = form.querySelector(`label[for="${box.id}"]`);
      (label || box).scrollIntoView({ block: 'nearest' });
      if (label) label.focus({ preventScroll: true });
    });

    /* Clear it the moment they tick it, rather than making them submit again to find out. */
    box.addEventListener('change', () => {
      if (box.checked) setError(box, false);
    });
  }

  function start() {
    document.querySelectorAll('.js-newsletter-terms').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
